module.exports = __webpack_public_path__ + "static/background-e74bb212675fa5e3b6547b67129ec618.jpg";